import React from 'react';
import styles from './Intuitive.module.css';

// Replace with your actual image paths
import image1 from '../../../assets/intuitive-asset1.png'; 
import image2 from '../../../assets/intuitive-asset3.png';

const Intuitive = () => {
  return (
    <section className={styles.intuitive}>
     <div className={styles.intuitiveSection}>
        <div className={styles.imageSection}>
          <img src={image1} alt="Image Mid-Left" className={styles.assetMidLeft}/>
          <img src={image2} alt="Image Top-Right" className={styles.assetTopRight}/>
        </div>
        <h1 className={styles.intuitiveTitle}>INTUITIVE</h1>
      </div>
    </section>
  );
};

export default Intuitive;
